import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import sports from '../../assets/images/sport_ill.png'
import unity from "../../assets/images/unity.png";

export default function AdminLogin() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [disableBtn, setDisableBtn] = useState(false);
  const navigate = useNavigate(null);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    setDisableBtn(true);
    e.preventDefault();
    // navigate("/admin-panel/dashboard");
    // return;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/login`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.statusCode === 200) {
        localStorage.setItem("sansadToken", response.data.result.token);
        localStorage.setItem("role", response.data.result.role);
        toast.success("Logged in successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        navigate("/admin-panel/dashboard");
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
    }
    setDisableBtn(false);
  };

  return (
    <div className="flex lg:flex-row flex-col lg:justify-around justify-center border items-center lg:h-screen h-screen py-10">
      <ToastContainer />
      <div className="lg:w-[50%] w-full flex justify-center items-center">
        <img src={unity} alt="" className="lg:h-[500px] h-full" />
      </div>
      <div className="lg:w-[50%] w-full flex justify-center items-center">
        <div className="lg:w-[500px] w-[300px] flex flex-col items-center justify-center">
          <div className="w-full">
            <h2 className="lg:text-4xl text-3xl font-semibold tracking-light text-center">
              Sansar Sadasya Admin
            </h2>
          </div>
          <div className="mt-16 flex justify-between w-full">
            <div className="">
              <h3 className="text-xl font-semibold tracking-wide">Sign In</h3>
            </div>
            {/* <div className="">
              <Link className="text-[#ff4141] text-sm" to="/admin-panel/send-otp">Forgot Password</Link>
            </div> */}
          </div>
          <div className="w-full mt-10">
            <form action="" className="w-full" onSubmit={handleSubmit}>
              <div className="w-full">
                <input
                  type="text"
                  className="border border-[grey] rounded-md h-[46px] w-full px-3 !outline-none text-sm"
                  placeholder="Enter Email Here ..."
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="w-full mt-6">
                <input
                  type="password"
                  className="border border-[grey] rounded-md h-[46px] w-full px-3 !outline-none text-sm"
                  placeholder="Enter Password Here..."
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mt-10">
                <button
                  type="submit"
                  className="rounded-md h-[46px] w-full bg-[#2c2c38] text-white hover:bg-[#191919]"
                  disabled={disableBtn}
                >
                  {disableBtn ? "Please Wait ..." : "Sign In"}
                </button>
              </div>
              <div className="">
                <p className="text-sm text-center mt-6">
                  Go to website ?{" "}
                  <Link className="text-[#ff4141]" to="/">
                    Click Here
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
